import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AppComponent} from './app.component';
import {AppRoutingModule, routedComponents} from './app-routing.module';
import {ChartModule} from 'angular-highcharts';
import {TextMaskModule} from 'angular2-text-mask';
import {ToastrModule} from 'ngx-toastr';
import {Angulartics2Module} from 'angulartics2';
import {LiveTileComponent} from './tiles/live/live-tile/live-tile.component';
import {LiveDetailsComponent} from './tiles/live/live-details/live-details.component';
import {
    AppliancesTileComponent
} from './tiles/appliances/appliances-tile/appliances-tile.component';
import {
    AppliancesDetailsComponent
} from './tiles/appliances/appliances-detail/appliances-detail.component';
import {TodayTileComponent} from './tiles/today/today-tile/today-tile.component';
import {TodayDetailsComponent} from './tiles/today/today-details/today-details.component';
import {CompareTileComponent} from './tiles/compare/comparison-tile/comparison-tile.component';
import {
    ComparisonDetailsComponent
} from './tiles/compare/comparison-details/comparison-details.component';
import {MeterTileComponent} from './tiles/meter/meter-tile/meter-tile.component';
import {MeterDetailsComponent} from './tiles/meter/meter-details/meter-details.component';
import {FinanceTileComponent} from './tiles/finance/finance-tile/finance-tile.component';
import {FinanceDetailsComponent} from './tiles/finance/finance-details/finance-details.component';
import {
    ConsumptionAlertTileComponent
} from './tiles/consumption-alert/consumption-alert-tile/consumption-alert-tile.component';
import {
    ConsumptionAlertDetailsComponent
} from './tiles/consumption-alert/consumption-alert-details/consumption-alert-detail.component';
import {ApiService} from './services/api.service';
import {MockDataService} from './services/mock-data.service';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {
    ConnectionIndicatorComponent
} from './components/connection-indicator/connection-indicator.component';
import {HeightControlDirective} from './directives/height-control.directive';
import {UserService} from './services/user.service';
import {
    PowerCheckerTileComponent
} from './tiles/powerchecker/powerchecker-tile/powerchecker-tile.component';
import {
    PowerCheckerDetailsComponent
} from './tiles/powerchecker/powerchecker-details/powerchecker-details.component';
import {PowerSwitchComponent} from './tiles/powerchecker/power-switch/power-switch.component';
import {MovableDirective} from './directives/movable.directive';
import {NguCarouselModule} from '@ngu/carousel';
import {NgxHmCarouselModule} from 'ngx-hm-carousel';
import {PowercheckerStateService} from './services/powerchecker-state.service';
import {
    RemainingTimeIndicatorComponent
} from './components/remaining-time-indicator/remaining-time-indicator.component';
import player from 'lottie-web';
import {MvpTileComponent} from './tiles/mvp/mvp-tile/mvp-tile.component';
import {MvpDetailsComponent} from './tiles/mvp/mvp-details/mvp-details.component';
import {PortalModule} from '@angular/cdk/portal';
import {TariffDataEntryComponent} from './popovers/tariff-data-entry/tariff-data-entry.component';
import {PopoverComponent} from './popovers/popover/popover.component';
import {OverlayModule} from '@angular/cdk/overlay';
import {TariffHistoryComponent} from './popovers/tariff-history/tariff-history.component';
import {ChangelogComponent} from './popovers/changelog/changelog.component';
import {LiveChartComponent} from './charts/live-chart/live-chart.component';
import {MenuComponent} from './components/menu/menu.component';
import {AddTileComponent} from './popovers/add-tile/add-tile.component';
import {SortTilesComponent} from './popovers/sort-tiles/sort-tiles.component';
import {
    BinaryConfirmPopoverComponent
} from './popovers/binary-confirm-popover/binary-confirm-popover.component';
import {TileWrapComponent} from './tiles/tile-wrap/tile-wrap.component';
import {HalfCircleDirective} from './directives/half-circle.directive';
import {
    ConsumptionAlertChartComponent
} from './charts/consumption-alert-chart/consumption-alert-chart.component';
import {MatchParentHeightDirective} from './directives/match-parent-height.directive';
import {ChangeEmailComponent} from './popovers/change-email/change-email.component';
import {ResetPasswordComponent} from './popovers/reset-password/reset-password.component';
import {CountSelectorComponent} from './components/count-selector/count-selector.component';
import {TabSelectorComponent} from './components/tab-selector/tab-selector.component';
import {InfoPopoverComponent} from './popovers/info-popover/info-popover.component';
import {EonSliderComponent} from './components/eon-slider/eon-slider.component';
import {BannerComponent} from './components/banner/banner.component';
import {UpdatePopoverComponent} from './popovers/update-popover/update-popover.component';
import {
    EnergySaverControlComponent
} from './popovers/energy-saver-control/energy-saver-control.component';
import {
    ValueEntryPopoverComponent
} from './popovers/value-entry-component/value-entry-popover.component';
import {
    EnergySaverBannerComponent
} from './components/energy-saver-banner/energy-saver-banner.component';
import {MatchHeightDirective} from './directives/match-height.directive';
import {MatchWidthDirective} from './directives/match-width.directive';
import {InfoViewComponent} from './popovers/info-view/info-view.component';
import {OptInPopoverComponent} from './popovers/opt-in-popover/opt-in-popover.component';
import {BatteryLoadComponent} from './components/battery-load/battery-load.component';
import {MfaCodePopoverComponent} from './popovers/mfa/mfa-code-popover/mfa-code-popover.component';
import {
    MfaCodeEntryPopoverComponent
} from './popovers/mfa/mfa-code-entry-popover/mfa-code-entry-popover.component';
import {
    MfaLoginPopoverComponent
} from './popovers/mfa/mfa-login-popover/mfa-login-popover.component';
import {
    DatePickerButtonComponent
} from './components/date-picker-button/date-picker-button.component';
import {HelpComponent} from './help/help.component';
import {
    NilmDevicePopoverComponent
} from './popovers/nilm-device-popover/nilm-device-popover.component';
import {ToggleComponent} from './components/toggle/toggle.component';
import {ApplianceChartComponent} from './charts/appliance-chart/appliance-chart.component';
import {LottieModule} from 'ngx-lottie';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {AuthInterceptorService} from './services/auth-interceptor.service';

declare var require: any;

const Highcharts = require('highcharts');
Highcharts.setOptions({
    global: {
        timezoneOffset: new Date().getTimezoneOffset()
    },
    lang: {
        thousandsSep: '.',
        decimalPoint: ',',
        loading: 'Auswertung wird geladen...',
        months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
        shortMonths: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
        weekdays: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
        shortWeekdays: ['Son', 'Mon', 'Die', 'Mit', 'Don', 'Fre', 'Sam']
    }
});

export function playerFactory() {
    return player;
}

@NgModule({
    imports: [
        AppRoutingModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ChartModule,
        TextMaskModule,
        // SortablejsModule.forRoot({
        //     animation: 150
        // }),
        ToastrModule.forRoot({
            timeOut: 3000,
            maxOpened: 2,
            positionClass: 'toast-bottom-right',
            toastClass: 'toast'
        }),
        Angulartics2Module.forRoot(),
        HttpClientModule,
        NguCarouselModule,
        NgxHmCarouselModule,
        LottieModule.forRoot({
            player: playerFactory
        }),
        PortalModule,
        OverlayModule,
        ReactiveFormsModule,
        DragDropModule
    ],
    declarations: [
        AppComponent,
        routedComponents,
        LiveTileComponent,
        LiveDetailsComponent,
        AppliancesTileComponent,
        AppliancesDetailsComponent,
        TodayTileComponent,
        TodayDetailsComponent,
        CompareTileComponent,
        ComparisonDetailsComponent,
        MeterTileComponent,
        MeterDetailsComponent,
        FinanceTileComponent,
        FinanceDetailsComponent,
        ConsumptionAlertTileComponent,
        ConsumptionAlertDetailsComponent,
        ConnectionIndicatorComponent,
        HeightControlDirective,
        PowerCheckerTileComponent,
        PowerCheckerDetailsComponent,
        PowerSwitchComponent,
        MovableDirective,
        RemainingTimeIndicatorComponent,
        MvpTileComponent,
        MvpDetailsComponent,
        TariffDataEntryComponent,
        PopoverComponent,
        TariffHistoryComponent,
        ChangelogComponent,
        LiveChartComponent,
        MenuComponent,
        AddTileComponent,
        SortTilesComponent,
        BinaryConfirmPopoverComponent,
        TileWrapComponent,
        MatchHeightDirective,
        MatchWidthDirective,
        HalfCircleDirective,
        ConsumptionAlertChartComponent,
        MatchParentHeightDirective,
        ChangeEmailComponent,
        ResetPasswordComponent,
        CountSelectorComponent,
        TabSelectorComponent,
        InfoPopoverComponent,
        EonSliderComponent,
        EnergySaverBannerComponent,
        EnergySaverControlComponent,
        BannerComponent,
        ValueEntryPopoverComponent,
        UpdatePopoverComponent,
        InfoViewComponent,
        OptInPopoverComponent,
        BatteryLoadComponent,
        MfaCodePopoverComponent,
        MfaCodeEntryPopoverComponent,
        MfaLoginPopoverComponent,
        DatePickerButtonComponent,
        HelpComponent,
        NilmDevicePopoverComponent,
        ToggleComponent,
        ApplianceChartComponent
    ],
    providers: [
        ApiService,
        MockDataService,
        UserService,
        PowercheckerStateService,
        {
            provide: 'googleTagManagerId', useValue: 'GTM-W84P3V9'
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptorService,
            multi: true
        }
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
    bootstrap: [AppComponent]
})

export class AppModule {
}
